import { INSURANCE_COMPANIES_STATS_EVENTS } from './global-events';

export const insuranceCompaniesSlideMenuItems = [
  {
    name: 'Проданих страхових компаній  ₴',
    event: INSURANCE_COMPANIES_STATS_EVENTS.INSURANCE_COMPANIES_STATS_AMOUNT,
  },
  {
    name: 'Проданих страхових компаній ШТ',
    event: INSURANCE_COMPANIES_STATS_EVENTS.INSURANCE_COMPANIES_STATS_COUNT,
  },
  {
    name: 'Комісійні винагороди по страхових компаніях ₴',
    event: INSURANCE_COMPANIES_STATS_EVENTS.INSURANCE_COMPANIES_STATS_EARNINGS,
  },
];
